import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FirebaseAuthContext } from '../../../auth/FirebaseAuth';
import Login from '../Login/Login.component';
import UserTypeSelector from '../../../components/UserTypeSelector/UserTypeSelector.component';
import CSCOwnerAuth from '../../../components/CSCOwnerAuth/CSCOwnerAuth.component';
import './LoginPage.styles.scss';

const LoginPage = () => {
  const { firebaseAuth } = useContext(FirebaseAuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const from = location.state?.from?.pathname || '/';

  const [userType, setUserType] = useState(null);
  const [, setIsUserLoggedIn] = useState(false);
  const [, setUserInfo] = useState(null);
  const [, setDisplayName] = useState(null);

  // If already authenticated, skip the login page immediately.
  useEffect(() => {
    const alreadyIn =
      !!firebaseAuth.currentUser ||
      !!localStorage.getItem('isUserLoggedIn') ||
      !!localStorage.getItem('cscOwnerLoggedIn');
    if (alreadyIn) navigate(from, { replace: true });
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  // Called by Login (customer) after successful sign-in.
  // CSCOwnerAuth handles its own navigate('/csc-portal') internally.
  const handleCustomerLoginSuccess = () => {
    navigate(from, { replace: true });
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        {userType === null && (
          <UserTypeSelector
            onSelect={setUserType}
            onClose={() => navigate('/')}
          />
        )}

        {userType === 'customer' && (
          <Login
            setOpen={handleCustomerLoginSuccess}
            setIsUserLoggedIn={setIsUserLoggedIn}
            setUserInfo={setUserInfo}
            setDisplayName={setDisplayName}
            onBack={() => setUserType(null)}
            redirectTo={from}
          />
        )}

        {userType === 'csc-owner' && (
          <CSCOwnerAuth
            onClose={() => setUserType(null)}
            onBack={() => setUserType(null)}
          />
        )}
      </div>
    </div>
  );
};

export default LoginPage;
